import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  INVITATION_FROM_YOU,
  INVITATION_TO_YOU,
  SOCIAL_MESSAGE,
  STORYLET_MESSAGE,
} from 'constants/messageTypes';

import { deleteMessage } from 'actions/messages';

import SocialMessage from './SocialMessage';
import StoryletMessage from './StoryletMessage';
import InvitationFromYou from './InvitationFromYou';
import InvitationToYou from './InvitationToYou';

import MessageComponent from './MessageComponent';

class MessageContainer extends Component {
  mounted = false

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  /**
   * Delete Message
   * @return {undefined}
   */
  handleDelete = () => {
    const { data, dispatch } = this.props;
    const id = data.relatedId;
    if (!id && id !== 0) {
      return; // no message id
    }

    dispatch(deleteMessage(id));
  }

  /**
   * RenderSocialMessage
   * @return {Object}
   */
  render() {
    const { data, disabled } = this.props;
    switch (data.type) {
      case INVITATION_FROM_YOU:
        return <InvitationFromYou data={data} disabled={disabled} />;
      case INVITATION_TO_YOU:
        return <InvitationToYou data={data} disabled={disabled} />;
      case SOCIAL_MESSAGE:
        return <SocialMessage data={data} disabled={disabled} />;
      case STORYLET_MESSAGE:
        return <StoryletMessage data={data} disabled={disabled} />;
      default:
        return <MessageComponent data={data} deletable onDelete={this.handleDelete} />;
    }
  }
}

MessageContainer.displayName = 'MessageContainer';

MessageContainer.propTypes = {
  data: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

MessageContainer.defaultProps = {
  disabled: false,
};

const mapStateToProps = ({ messages: { isRequesting: disabled } }) => ({ disabled });

export default connect(mapStateToProps)(MessageContainer);
